import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CallState, LoadingState } from '@lcs/shared/api';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PasswordFormService } from 'src/app/common-components/password-form-control/password-form.service';
import { NgChanges } from 'src/lib/ng-changes';

import { AccountFinalizationFormValue } from '../models/account-finalization.form';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-account-verification-view',
    styleUrls: ['./account-verification-view.component.scss'],
    templateUrl: './account-verification-view.component.html',
    standalone: false
})
export class AccountVerificationViewComponent implements OnChanges, OnDestroy {
   @Input() callState: CallState;

   @Input() canAccountBeFinalized: boolean | null;

   @Input() emailAddress: string | null;

   @Input() submitState$: Observable<CallState>;

   // eslint-disable-next-line @typescript-eslint/member-ordering
   @Output() formSubmitted = new EventEmitter<AccountFinalizationFormValue>();

   errorMessage: string;

   form: UntypedFormGroup;

   get isLoading(): boolean {
      return this.callState === LoadingState.Loading;
   }

   submitState: CallState;

   private destroyed$ = new Subject<void>();

   constructor(private formService: PasswordFormService, private router: Router) {
      this.formService.initResetPasswordViewForm();
      this.form = formService.form;
   }

   ngOnChanges(changes: NgChanges<AccountVerificationViewComponent>): void {
      const submitState: Observable<CallState> = changes.submitState$?.currentValue;
      if (submitState) {
         this.submitState$.pipe(takeUntil(this.destroyed$)).subscribe((value) => {
            this.submitState = value;
         });
      }
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSubmit(): void {
      if (this.form.invalid) {
         this.formService.markControlsTouched();
      }
      if (this.form.valid && this.form.dirty) {
         const formValue: AccountFinalizationFormValue = this.form.value;
         this.formSubmitted.emit(formValue);
      }
   }

   continue(): void {
      let redirectRoute = '/login';
      if (this.emailAddress) {
         redirectRoute = redirectRoute + '?username=' + this.emailAddress;
      }

      this.router.navigateByUrl(redirectRoute);
   }
}
